'use strict';
var parent = require('../../actual/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/filter.js
// module id = 620
// module chunks = 13